export default "__VITE_ASSET__uAtSESQz__"